'use client'
import DevOpsLanding from '../components/DevOpsLanding'
import CTA from '../components/CTA'

export default function DevOpsPage() {
  return (
    <>
      <DevOpsLanding />
      <CTA />
    </>
  )
}
